// extracted by mini-css-extract-plugin
export default {"container":"NoticeListPage_container__+4xqR","content":"NoticeListPage_content__gtTA5"};